var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pr-2"},_vm._l((_vm.threads),function(thread){return _c('thread',{key:thread.id,attrs:{"thread":thread,"role":"freelancer"},on:{"click":_vm.openThread}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }